import * as ReactDOM from 'react-dom';

export type Render = typeof ReactDOM.render;

export const render = ReactDOM.render;